export const MAX_POLL_COUNT = 30
export const pollDelays = [5000, 10000, 20000, 40000, 80000]
